export function StatCard({ icon, label, value }) {
    return (
        <div className="admin-metric-card" data-testid={`stat-${label.toLowerCase().replace(' ', '-')}`}>
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/20 flex items-center justify-center text-primary">
                    {icon}
                </div>
                <div>
                    <p className="text-xs uppercase tracking-widest text-muted-foreground">{label}</p>
                    <p className="text-2xl font-bold" style={{ fontFamily: "'Silkscreen', cursive" }}>{value}</p>
                </div>
            </div>
        </div>
    );
}
